import React from 'react';
import Section from './Section';

const jobs = [
    {
        role: 'Software Engineer',
        org: 'PhonePe',
        text: 'Building LLM systems at scale: workflow executors, multi-agent retrieval, LLM-as-judge evaluations, and production search. I own services end to end — design, infra, deployment.',
        stack: 'LLM · RAG · Agents · Search',
    },
    {
        role: 'Software Development Engineer',
        org: 'Bajaj Finserv Health',
        text: 'Owned health-tech journeys on Spring Boot, Kafka, MongoDB, and Redis — policy issuance through utilization. Led developers and interns.',
        stack: null,
    },
];

export default function Experience() {
    return (
        <Section id="experience" title="Experience">
            {jobs.map((j) => (
                <article className="item" key={j.org}>
                    <h3 className="item-title">
                        {j.role} <span className="item-org">— {j.org}</span>
                    </h3>
                    <p className="item-text">{j.text}</p>
                    {j.stack && <p className="meta">{j.stack}</p>}
                </article>
            ))}

            <article className="item">
                <h3 className="item-title">Earlier</h3>
                <p className="item-text">
                    SDE internships at HealthRx and Tuzo — Spring Boot and
                    Node.js services, Kubernetes, Azure pipelines; MLOps on
                    Kubeflow with Seldon Core.
                </p>
            </article>

            <article className="item">
                <h3 className="item-title">Open Source</h3>
                <p className="item-text">
                    Fixes and developer-experience improvements across
                    Elasticsearch, Supabase, Appsmith, and Netlify.
                </p>
            </article>
        </Section>
    );
}
